
<div>
  <app-back-button></app-back-button>
  <form class="form" [formGroup]="form">
    @if (!editForm) {
      <div>
        <h3 class="mat-headline-3">{{header}}</h3>
      </div>
    }
    @if (editForm) {
      <div>
        <app-well-details-header [wellRequest]="wellRequest"></app-well-details-header>
        <div class="cancel-button">
          @if (!wellRequest?.isInRts) {
            <app-cancel-request-button [wellRequestId]="wellRequest?.id"></app-cancel-request-button>
          }
        </div>
        <app-well-details-admin></app-well-details-admin>
        <mat-divider></mat-divider>
      </div>
    }
    <div class="mat-input-d-3" [ngClass]="{'form-content': !editForm}">
      @if (!wellRequest?.isInRts) {
        <div>
          <mat-label for="name">Well Name</mat-label><br />
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input matInput
              name="name"
              formControlName="name"
              maxlength="50"
              placeholder="Enter well name..."
              required>
            </mat-form-field>
          </div>
      }
        <div>
          <app-chip #chipComponent label="VIDA ID's"
            placeholder="Select ID's..."
            [dataSource]="filteredJobs"
            [selectedSourceItems]="selectedJobs"
            formControlName="job"
            [closeEvent]="closeEvent"
            app-autocomplete-validator>
          </app-chip>
        </div>
        <div>
          <app-select label="Region"
            placeholder="Enter region..."
            [dataSource]="regionDataForDropdown"
            formControlName="region"
            app-autocomplete-validator
            required>
          </app-select>
        </div>
        <div>
          <app-select label="Country"
            placeholder="Enter country..."
            [dataSource]="filteredCountries"
            formControlName="country"
            app-autocomplete-validator
            required>
          </app-select>
        </div>
        <div>
          <app-chip #chipComponent label="Group Name"
            placeholder="Enter group..."
            [dataSource]="filteredGroups"
            (selectedItemsEvent)="groupsSelectionChanged($event)"
            (removeEvent)="groupsRemoveChanged($event)"
            [selectedSourceItems]="selectedGroups"
            formControlName="group"
            [closeEvent]="closeEvent"
            app-autocomplete-validator
            [required]="true">

          </app-chip>
        </div>
        <div class="nwa-info-item">
          <mat-label>NWA</mat-label>
          @if (selectedGroups?.length) {
            <span>
              @for (group of uniqueNWA; track group; let last = $last) {
                {{ group.nwa }}@if (!last) {
                <span style="padding:0px; margin:0px">, </span>
              }
            }
          </span>
        } @else {
          <span>N/A</span>
        }
      </div>

      <div>
        <mat-label for="state">State</mat-label><span>&nbsp;(optional)</span><br />
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <input matInput
            name="state"
            formControlName="state"
            maxlength="50"
            placeholder="Enter state..."              
            [matAutocomplete]="stateAuto">
          </mat-form-field>
          <mat-autocomplete #stateAuto="matAutocomplete">
              <mat-option *ngFor="let option of filteredStateOptions | async" [value]="option">
                {{ option }}
              </mat-option>
          </mat-autocomplete>
        </div>
        <div>
          <mat-label for="district">District</mat-label><span>&nbsp;(optional)</span><br />
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <input matInput
              name="district"
              formControlName="district"
              maxlength="50"
              placeholder="Enter district..."                    
              [matAutocomplete]="districtAuto">
          </mat-form-field>
          <mat-autocomplete #districtAuto="matAutocomplete">
              <mat-option *ngFor="let option of filteredDistrictOptions | async" [value]="option">
                {{ option }}
              </mat-option>
          </mat-autocomplete>
          </div>
          <div>
            <app-select label="Operator"
              placeholder="Enter operator..."
              [dataSource]="operators"
              [displayFormat]="operatorDisplayFormat"
              formControlName="operator"
              app-autocomplete-validator
              required>
            </app-select>
          </div>

          <mat-grid-list cols="2" rowHeight="100px" gutterSize="30px">
            <mat-grid-tile>
              <div>
                <mat-label for="latitude">Surface Latitude</mat-label><br />
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input matInput
                    name="latitude"
                    formControlName="latitude"
                    placeholder="Enter latitude..."
                    decimaNumber=6
                    required>
                  </mat-form-field>
                </div>
              </mat-grid-tile>
              <mat-grid-tile>
                <div>
                  <mat-label for="longitude">Surface Longitude</mat-label><br />
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <input matInput
                      name="longitude"
                      formControlName="longitude"
                      placeholder="Enter longitude..."
                      decimaNumber=6
                      required>
                    </mat-form-field>
                  </div>
                </mat-grid-tile>
              </mat-grid-list>

              <div>
                <mat-label for="wellApiNumber">Well API#</mat-label><span>&nbsp;(optional)</span><br />
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input matInput
                    name="wellApiNumber"
                    formControlName="wellApiNumber"
                    maxlength="200"
                    placeholder="Enter Well API#..."
                    [matAutocomplete]="wellNumAuto">
                  </mat-form-field>
                  <mat-autocomplete #wellNumAuto="matAutocomplete">
                      <mat-option *ngFor="let option of filteredWellNumOptions | async" [value]="option">
                        {{ option }}
                      </mat-option>
                    </mat-autocomplete>
                </div>

                <div>
                  <mat-label for="wellType">Well Type</mat-label><span>&nbsp;(optional)</span><br />
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <input matInput
                      name="wellType"
                      formControlName="wellType"
                      maxlength="20"
                      placeholder="Enter Well Type..."
                      [matAutocomplete]="wellTypeAuto">
                      <mat-autocomplete #wellTypeAuto="matAutocomplete">
                        <mat-option *ngFor="let option of filteredWellTypeOptions | async" [value]="option">
                          {{ option }}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>

                  <mat-grid-list cols="2" rowHeight="100px" gutterSize="30px">
                    <mat-grid-tile>
                      <div>
                        <mat-label for="wellDepth">Depth</mat-label><br />
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                          <input matInput
                            name="wellDepth"
                            formControlName="wellDepth"
                            placeholder="Enter Well Depth..."
                            decimaNumber=3
                            required
                            [matAutocomplete]="depthAuto">
                          </mat-form-field>
                          <mat-autocomplete #depthAuto="matAutocomplete">
                              <mat-option *ngFor="let option of filteredDepthOptions | async" [value]="option">
                                {{ option }}
                              </mat-option>
                            </mat-autocomplete>
                        </div>
                      </mat-grid-tile>
                      <mat-grid-tile>
                        <div>
                          <mat-label for="wellUOM">UoM</mat-label><br />
                          <mat-form-field appearance="outline" subscriptSizing="dynamic">
                            <input matInput
                              name="wellUOM"
                              formControlName="wellUOM"
                              maxlength="12"
                              placeholder="Enter UoM..."
                              [matAutocomplete]="uomAuto"
                              required>
                            <mat-autocomplete #uomAuto="matAutocomplete">
                              <mat-option *ngFor="let option of filteredUomOptions | async" [value]="option">
                                {{ option }}
                              </mat-option>
                            </mat-autocomplete>
                            </mat-form-field>
                          </div>
                        </mat-grid-tile>
                      </mat-grid-list>

                      <div>
                        <mat-label for="wellOrientation">Well Orientation</mat-label><span>&nbsp;(optional)</span><br />
                        <mat-form-field appearance="outline" subscriptSizing="dynamic">
                          <input matInput
                            name="wellOrientation"
                            formControlName="wellOrientation"
                            maxlength="20"
                            placeholder="Enter Well Orientation..."
                            [matAutocomplete]="orientationAuto">
                            <mat-autocomplete #orientationAuto="matAutocomplete">
                              <mat-option *ngFor="let option of filteredOrientationOptions | async" [value]="option">
                                {{ option }}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </div>

                        <div>
                          <mat-checkbox formControlName="isRigless">Rigless</mat-checkbox>
                        </div>

                        @if (!isRiglessControl.value) {
                          <div>
                            <app-select label="Rig"
                              placeholder="Enter rig..."
                              [dataSource]="filteredRigs"
                              formControlName="rig"
                              app-autocomplete-validator
                              required>
                            </app-select>
                          </div>

                          <div>
                            <mat-label for="rigOwner">Rig Owner Company</mat-label><span>&nbsp;(optional)</span><br />
                            <mat-form-field appearance="outline" subscriptSizing="dynamic">
                              <input matInput
                                name="rigOwner"
                                formControlName="rigOwner"
                                maxlength="140"
                                placeholder="Enter rig owner company..."
                                [matAutocomplete]="rigOwnerAuto">
                              <mat-autocomplete #rigOwnerAuto="matAutocomplete">
                                <mat-option *ngFor="let option of filteredRigOwnerOptions | async" [value]="option">
                                  {{ option }}
                                </mat-option>
                              </mat-autocomplete>
                            </mat-form-field>
                          </div>

                            <div>
                              <mat-label for="rigType">Rig Drilling Type</mat-label><span>&nbsp;(optional)</span><br/>
                              <mat-form-field appearance="outline" subscriptSizing="dynamic">
                                <input matInput
                                  name="rigType"
                                  formControlName="rigType"
                                  maxlength="140"
                                  placeholder="Enter rig drilling type..."
                                  [matAutocomplete]="rigTypeAuto">
                                <mat-autocomplete #rigTypeAuto="matAutocomplete">
                                  <mat-option *ngFor="let option of filteredRigTypeOptions | async" [value]="option">
                                    {{ option }}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                              </div>

                              <div>
                                <mat-label>Rig Source</mat-label><br />
                                <span class="readonly-field">{{getRigSourceDisplay()}}</span>
                              </div>
                        }

                        <div>
                          <mat-label>Well Source</mat-label><br />
                          <span class="readonly-field">{{ getWellSourceDisplay() }}</span>
                        </div>

                            <div>
                              <div style="margin:0px 0px -28px 50px;">
                                <mat-icon matTooltip="A group name selection is needed to enable admin list" style="font-size: 21px; color: blue">info</mat-icon>
                              </div>
                              <app-chip #chipComponent label="Admin"
                                placeholder="Enter admin..."
                                [dataSource]="filteredAdmins"
                                [selectedSourceItems]="selectedAdmins"
                                [isRemovableFunc]="isAdminRemovable"
                                [count]=5
                                formControlName="admin"
                                app-autocomplete-validator
                                [required]="true">
                              </app-chip>
                            </div>
                            @if (editForm) {
                              <app-well-details-comments></app-well-details-comments>
                            }
                          </div>

                          @if (editForm) {
                            <div class="well-info-item">
                              <mat-label for="comments">Comments</mat-label><br />
                              <mat-form-field appearance="outline" subscriptSizing="dynamic" class="comments">
                                <textarea matInput
                                  formControlName="comments"
                                  cdkTextareaAutosize
                                  #autosize="cdkTextareaAutosize"
                                  cdkAutosizeMinRows="6"
                                  cdkAutosizeMaxRows="6"
                                  maxlength="250"
                                  (keydown.enter)="onCommentsEnter($event)">
                                </textarea>
                              </mat-form-field>
                            </div>

                            <div class="form-buttons">
                              <a mat-raised-button (click)="back()" class="reset-button accent-button" color="accent">Cancel</a>
                              &nbsp;
                              <button mat-raised-button type="submit" color="primary" class="submit-button primary-button" [disabled]="form.invalid" (click)="openDialogApprove()">Approve</button>
                            </div>
                          } @else {
                          <app-submit-cancel-button [disableSubmit]="form.invalid" [form]="form" [popupSubmitData]="popupSubmitData" (submitedEvent)="submitHandler($event)"></app-submit-cancel-button>
                          }
                        </form> 
                      </div>
